import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FinoIconModule } from '@fino-ui/icon';
import { TranslationModule } from '@fino-ui/translation';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrl: './info.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslationModule, FinoIconModule],
})
export class InfoComponent {
  title = input<string>();
}
